import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, useTheme } from '@mui/material';
import { DisconnectApproachDialogProps } from './DisconnectApproachDialog.props';
import { GridContainer, StyledDeleteIcon } from './DisconnectApproachDialog.styles';

const DisconnectApproachDialog = ({ open, actions, onClose }: DisconnectApproachDialogProps) => {
  const theme = useTheme();
  const message = `
  Not keeping your comp groups up to date with Scalar's comp groups will disconnect your valuations
  from the Scalar provided comp group and you will no longer be prompted with future updates.
  You can re-add Scalar's comp group to any Valuation again in the future if desired.
  `;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent style={{ padding: theme.spacing(2), marginBottom: theme.spacing(2) }}>
        <GridContainer container direction="row">
          <Grid item container justifyContent="center">
            <StyledDeleteIcon className="message-box__inside-icon-error" />
          </Grid>
          <Grid item>
            <p className="message-box__tagline" style={{ textAlign: 'center' }}>
              {message}
            </p>
          </Grid>
        </GridContainer>
      </DialogContent>
      <DialogActions style={{ margin: 0, padding: theme.spacing(2) }}>
        {actions.map(action => (
          <Button
            key={action.label}
            onClick={action.callback}
            variant={action.variant}
            sx={
              action.type === 'danger'
                ? {
                  color: '#fff',
                  backgroundColor: theme.palette.error.main,
                  '&:hover': {
                    backgroundColor: theme.palette.error.light,
                  },
                }
                : {
                  color: theme.palette.primary.main,
                }
            }>
            {action.label}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
};

export default DisconnectApproachDialog;
